<template>
  <div class="row no-padding">
    <div
        class="row-height col-md-12 no-paddng"
        v-if="!isChildren"
        :class="showOverlay ? ' postion-relative' : ''">
      <div  class="wizard-absolute border-r-8 mt-4"
            v-if="showOverlay"
            @click="(dialog = false), (dialog1 = false), (showOverlay = false)">
      </div>
      <div class="col-md-12">
        <v-form ref="templateInfo">
        <v-row align="center" justify="center">
          <div class="col-md-12 navigationWidth no-padding">
            <v-row class="blue-underline mb-1">
              <v-col class="col-xl-4 col-md-5 cols-4 pt-2 pb-0" cols="4">
                <div class="col-md-12 p-0 d-flex">
                  <h3 class="form-title font col-md-6 font-16">Template Name: </h3>
                  <v-text-field
                    style="width: 50%"
                    class="input-control mr-5 mt-1 col-md-5"
                    light dense placeholder="Template name"
                    :rules="requiredRules1" outlined
                    v-model="title"
                ></v-text-field>
                </div>
              </v-col>
              <v-col
                  class="col-xl-6 mt-0 d-flex col-md-6 pr-2 cols-12 text-end"
                  cols="12" align="end">
           <h4 class="mt-4">  Description:</h4>
                <v-textarea class=" ml-2 mt-2 pl-2 pt-2"
                         auto-grow
                         variant="outlined"
                        rows="2"
                      row-height="15"
                          v-model="description"
                          required
                          :rules="requiredRules"
                          ></v-textarea>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-form>
      </div>
      <v-row class="no-paddng d-block">
        <div class="col-xl-2 col-lg-3 col-md-12 no-padding"  cols="12">
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 float-left">
          <div class="col-xl-11 col-lg-11 col-md-12 mt-1 pr-0 mr-1">
            Diagnosis Information | <a class="blue-text"  @click="FavoriteDiagnosis = true"> Favorites</a>
            <br>
            <div class="col-12 mb-2 d-flex pt-0">
              <div class="col-md-5 col-lg-5">
                <label for="" class="text-left mt-2 mb-2"
                       @click="searchDiagnose()">Search for Diagnosis</label>
                <v-text-field
                    style="width: 90%"
                    class="input-control mr-5 mt-1"
                    @keypress.enter="searchDiagnose"
                    v-model="diagnoseSearch"
                    light
                    dense
                    outlined
                ></v-text-field>
                </div>
                <div class="col-2">
                  <a  @click="searchDiagnose();">search</a>
                </div>
             <template>
                <v-row justify="center">
                  <!-- Diagnoses Modal -->
                  <v-dialog
                      v-model="DiagnosisDialog"
                      persistent max-width="80vw" max-height="60vh">
                    <v-card>
                      <v-card-title class=" mb-1">
                        <v-row class="blue-underline mb-3 mt-1">
                          <div class="mb-3 ml-1 d-flex">
                            <a class="mr-1" role="button"> Diagnoses</a> |
                             <p @click="openFavoriteDiagnosesDialog()" class="ml-1" role="button">Favorites</p>
                           </div>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-simple-table fixed-header height="50vh">
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-left">Index</th>
                              <th class="text-left">Description</th>
                              <th class="text-left">ICD Code</th>
                              <th class="text-left">Favorite</th>
                              <th class="">Select</th>
                            </tr>
                            </thead>
                            <v-progress-circular
                            style="margin-left: 20vw"
                            v-if="loader"
                            color="primary"
                            indeterminate
                          ></v-progress-circular>
                            <tbody v-for="(item,index) in diagnose" :key="index">
                            <tr>
                              <td>
                                {{index + 1}}
                              </td>
                              <td > {{item.description}}</td>
                              <td > {{item.code}}</td>
                              <td  @click="addFavoriteIcd(item, index)"> 
                                <v-rating
                                  color="yellow darken-3"
                                  background-color="grey darken-1"
                                  hover
                                  :value="item.star"
                                  length="1"
                              ></v-rating>
                              </td>
                              <td class="">
                                <v-checkbox
                                    color="primary"
                                    @click="checkIcds(item)"
                                    v-model="tmpIcds"
                                    :value="item._id"
                                ></v-checkbox>
                              </td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table></v-card-text>
                      <v-card-actions
                          style="border-top: 1px solid rgb(209, 207, 207)">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="DiagnosisDialog = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="addICDS();
                                    DiagnosisDialog = false;"
                        >
                          Add Selected
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
              <template>
                <v-row justify="center">
                  <!-- Favorite Diagnoses Table -->
                  <v-dialog
                      v-model="FavoriteDiagnosis"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                  >
                    <v-card>
                      <v-card-title class=" mb-1">
                        <v-row class="blue-underline mb-3 mt-1">
                          <div class="mb-3 ml-1 d-flex"><p @click="openDiagnosesDialog()" class="mr-1" role="button"> Diagnoses </p> | <a class="ml-1">Favorites</a></div>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-simple-table fixed-header height="50vh">
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-left">Favorites</th>
                              <th class="text-left">Description</th>
                              <th class="text-left">ICD Code</th>
                              <th class="text-left">Favorite</th>
                            </tr>
                            </thead>
                            <tbody  v-for="(item,index) in favoriteDiagnoses" :key="index">
                            <tr
                            >
                              <td>
                                {{index + 1}}
                              </td>
                              <td > {{item.description}}</td>
                              <td > {{item.code}}</td>
                              <td  @click="manageFavoriteIcd(item, index)"> 
                                <v-rating
                                  color="yellow darken-3"
                                  background-color="grey darken-1"
                                  hover
                                  :value="1"
                                  length="1"
                              ></v-rating>
                              </td>
                             
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table></v-card-text>
                      <v-card-actions
                          style="border-top: 1px solid rgb(209, 207, 207)">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteDiagnosis = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteDiagnosis = false;"
                        >
                          Add Selected
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
            </div>
            <!-- Diagnoses Table -->
            <v-simple-table fixed-header height="330px">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Rank</th>
                  <th class="text-left">ICD Code</th>
                  <th class="text-left">Description</th>
                  <th class="">Actions</th>
                </tr>
                </thead>
                <tbody  v-for="(item,index) in getIcdsList" :key="index" >
                <tr
                >
                  <td>
                    {{index + 1 }}
                  </td>
                  <td > {{item.code}}</td>
                  <td > {{item.description}}</td>
                  <td class="">
                    <svg role="button" @click="removeFromIcds(item)" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.7498 9.3335L9.41211 16.6668" stroke="#DC0101" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.41211 9.3335L16.7498 16.6668" stroke="#DC0101" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19.1957 2H6.96607C4.26438 2 2.07422 4.18883 2.07422 6.88889V19.1111C2.07422 21.8112 4.26438 24 6.96607 24H19.1957C21.8974 24 24.0876 21.8112 24.0876 19.1111V6.88889C24.0876 4.18883 21.8974 2 19.1957 2Z" stroke="#DC0101" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 float-right">
          <div  class="col-xl-11 col-lg-11 col-md-12 mt-1 pr-0 mr-1">
            Procedure Information | <a class="blue-text" @click="FavoriteProcedure =true"> Favorites</a>
            <br>
            <div class="mt-1">
            <label for="" class="text-left mt-2 mb-2"
             @click="searchProcedure()">Search for Procedure
              <a class="ml-5"
                 @click="searchProcedure();">search</a></label>
            <v-text-field
                style="width: 30%"
                class="input-control col-4 mr-5 mt-1"
                @keypress.enter="searchProcedure"
                v-model="procedureSearch"
                light
                dense
                outlined
            ></v-text-field>
            <template>
                <v-row justify="center">
                  <!-- Favorite Procedures Table -->
                  <v-dialog
                      v-model="FavoriteProcedure"
                      persistent
                      max-width="80vw"
                      max-height="60vh"
                  >
                    <v-card>
                      <v-card-title class=" mb-1">
                        <v-row class="blue-underline mb-3 mt-1">
                          <div class="mb-3 ml-1 d-flex">
                            <p @click="openProcedureDialog()" class="mr-1" role="button">Procedures</p>  | <a class="ml-1" role="button">Favorites</a>
                           </div>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-simple-table fixed-header height="50vh">
                          <template v-slot:default>
                            <thead>
                            <tr>
                              <th class="text-left">Favorites</th>
                              <th class="text-left">Description</th>
                              <th class="text-left">ICD Code</th>
                              <th class="text-left">Favorite</th>
                            </tr>
                            </thead>
                            <tbody  v-for="(item,index) in favoriteProcedures" :key="index" >
                            <tr
                            >
                              <td>
                                {{index + 1}}
                              </td>
                              <td > {{item.description}}</td>
                              <td > {{item.code}}</td>
                              <td  @click="manageFavoriteCpts(item, index)"> 
                                <v-rating
                                  color="yellow darken-3"
                                  background-color="grey darken-1"
                                  hover
                                  :value="1"
                                  length="1"
                              ></v-rating>
                              </td>
                            </tr>
                            </tbody>
                          </template>
                        </v-simple-table></v-card-text>
                      <v-card-actions
                          style="border-top: 1px solid rgb(209, 207, 207)">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteProcedure = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            class="text-underline"
                            text
                            @click="FavoriteProcedure = false;"
                        >
                          Add Selected
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </template>
      <template>
              <v-row justify="center">
                <!-- Procedures Modal -->
                <v-dialog
                    v-model="ProcedureDialog"
                    persistent
                    max-width="80vw"
                    max-height="60vh"
                >
                  <v-card>
                    <v-card-title class=" mb-1">
                      <v-row class="blue-underline mb-3 mt-1">
                        <div class="mb-3 ml-1 d-flex">
                          <a class="mr-1" role="button">Procedures</a>  |
                           <p @click="openFavoriteProcedureDialog()" class="ml-1" role="button">Favorites</p>
                         </div>
                      </v-row>
                    </v-card-title>
                    <v-card-text>
                      <v-simple-table fixed-header height="50vh">
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th class="text-left">Index</th>
                            <th class="text-left">Description</th>
                            <th class="text-left">CPT Code</th>
                            <th class="text-left">Favorite</th>
                            <th class="">Select</th>
                          </tr>
                          </thead>
                          <v-progress-circular
                          style="margin-left: 20vw"
                          v-if="loader"
                          color="primary"
                          indeterminate
                        ></v-progress-circular>
                          <tbody v-for="(item,index) in procedure" :key="index"  >
                          <tr
                          >
                            <td>
                              {{index + 1}}
                            </td>
                            <td > {{item.description}}</td>
                            <td > {{item.code}}</td>
                            <td @click="addFavoriteCpt(item,index)"> <v-rating
                                color="yellow darken-3"
                                background-color="grey darken-1"
                                hover
                                :value="item.star"
                                length="1"
                            ></v-rating></td>
                            <td class="">
                              <v-checkbox
                                  color="primary"
                                  @click="checkCpts(item)"
                                  v-model="tmpCpts"
                                  :value="item._id"
                              >
                              </v-checkbox>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table></v-card-text>
                    <v-card-actions
                        style="border-top: 1px solid rgb(209, 207, 207)">
                      <v-spacer></v-spacer>
                      <v-btn
                          color="primary"
                          class="text-underline"
                          text
                          @click="ProcedureDialog = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                          color="primary"
                          class="text-underline"
                          text
                          @click="
                          addCPTS();
                          ProcedureDialog = false"
                      >
                        Add Selected
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
         </div>
            <br>
            <br>
            <!-- Procedures Table -->
            <v-simple-table fixed-header height="430px" class="mt-4">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Rank</th>
                  <th class="text-left">Descritpion</th>
                  <th class="text-left">Qty</th>
                  <th class="text-left">Diagnosis Link</th>
                  <th class="">Actions</th>
                </tr>
                </thead>
                <tbody  v-for="(item,index) in getCptList" :key="index">
                <tr
                >
                  <td>
                    {{ index +1}}
                  </td>
                  <td > {{item.description}}</td>
                  <td > <v-select
                    class="pt-3"
                    solo
                    :items="numbers"
                    style="width: 70px"
                    v-model="item.quantity"
                  >
                  </v-select></td>
                  <td >  <v-select
                    solo
                    class="pt-3"
                    :items="itemIcds"
                    style="width: 160px"
                    item-value="_id"
                    item-text="code"
                    v-model="item.icdLink"
                  >
                  </v-select> </td>
                  <td class="">
                    <svg @click="removeFromCpt(item)" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.7498 9.3335L9.41211 16.6668" stroke="#DC0101" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9.41211 9.3335L16.7498 16.6668" stroke="#DC0101" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M19.1957 2H6.96607C4.26438 2 2.07422 4.18883 2.07422 6.88889V19.1111C2.07422 21.8112 4.26438 24 6.96607 24H19.1957C21.8974 24 24.0876 21.8112 24.0876 19.1111V6.88889C24.0876 4.18883 21.8974 2 19.1957 2Z" stroke="#DC0101" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </div>
      </v-row>

    </div>
    <div class="col-md-12 no-padding">
      <div class="gray-underline-wizard row margin-l-11">
        <div class="text-end justify-end col-md-12 mt-5 mb-5 pr-16">
          <span
              class="mr-10 text-underline pointer"
              style="color:#1976d2"
              @click="$router.go(-1)"
          >Cancel</span
          >
          <span
              class="mr-3 text-underline pointer"
              style="color:#1976d2"
              @click="submitTemplate()"
          >Submit
          </span>
        </div>
      </div>
      <successModal
      ref="success_modal"
      v-on:confirm="closeSuccessModal"
    ></successModal>
    <v-dialog
    hide-overlay
    v-model.trim="emptySearch"
    height="320"
    width="400"
    style="margin-top:30vh;"
    content-class="modal-member-check"
  >
    <v-card>
      <v-card-text>
        <div class="col-md-12 pt-10 text-center" @click="emptySearch = false">
          <div class="red-error-modal">
            <svg
              class="mt-3"
              width="37"
              height="37"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.7713 5.74543C24.1794 6.19751 24.6778 6.55892 25.2344 6.80627C25.7909 7.05363 26.3931 7.18144 27.0021 7.18144C27.6111 7.18144 28.2133 7.05363 28.7698 6.80627C29.3263 6.55892 29.8248 6.19751 30.2329 5.74543L32.3216 3.42968C32.9244 2.76457 33.718 2.30209 34.5938 2.10559C35.4696 1.90908 36.3847 1.98815 37.2138 2.33198C38.0429 2.6758 38.7455 3.26755 39.2253 4.02621C39.7052 4.78487 39.9388 5.67334 39.8942 6.56994L39.7342 9.68131C39.7033 10.2898 39.8003 10.898 40.0191 11.4667C40.2378 12.0353 40.5734 12.5518 41.0042 12.9826C41.435 13.4134 41.9513 13.7491 42.5198 13.9679C43.0884 14.1867 43.6965 14.2837 44.3049 14.2528L47.4157 14.0928C48.3145 14.0449 49.2061 14.2769 49.9676 14.7569C50.7291 15.2368 51.3231 15.941 51.6679 16.7725C52.0127 17.6041 52.0913 18.5221 51.8929 19.4002C51.6945 20.2783 51.2287 21.0732 50.5599 21.6756L48.2445 23.7647C47.7925 24.1729 47.4312 24.6714 47.1839 25.228C46.9366 25.7847 46.8088 26.387 46.8088 26.9961C46.8088 27.6052 46.9366 28.2075 47.1839 28.7641C47.4312 29.3208 47.7925 29.8193 48.2445 30.2275L50.5599 32.3165C51.2275 32.9189 51.6922 33.7132 51.8902 34.5904C52.0882 35.4676 52.0098 36.3846 51.6657 37.2155C51.3216 38.0463 50.7287 38.7501 49.9685 39.2303C49.2083 39.7105 48.3181 39.9435 47.4202 39.8972L44.3094 39.7372C43.701 39.7066 43.0931 39.8039 42.5247 40.0228C41.9563 40.2417 41.4401 40.5774 41.0094 41.0081C40.5787 41.4389 40.2431 41.9552 40.0243 42.5237C39.8054 43.0922 39.7081 43.7002 39.7387 44.3087L39.8987 47.42C39.9449 48.3181 39.712 49.2085 39.2319 49.9688C38.7518 50.7292 38.0481 51.3222 37.2174 51.6663C36.3867 52.0105 35.4699 52.0889 34.5929 51.8909C33.7158 51.6928 32.9216 51.228 32.3194 50.5603L30.2307 48.2445C29.8225 47.7925 29.3241 47.431 28.7676 47.1837C28.2111 46.9363 27.6089 46.8085 26.9999 46.8085C26.3909 46.8085 25.7886 46.9363 25.2321 47.1837C24.6756 47.431 24.1772 47.7925 23.7691 48.2445L21.6737 50.5625C21.0714 51.2302 20.2772 51.6951 19.4002 51.8931C18.5232 52.0912 17.6063 52.0127 16.7757 51.6685C15.945 51.3244 15.2413 50.7314 14.7612 49.971C14.2811 49.2107 14.0481 48.3203 14.0944 47.4222L14.2544 44.3109C14.2853 43.7024 14.1883 43.0941 13.9695 42.5255C13.7508 41.9568 13.4152 41.4404 12.9844 41.0096C12.5537 40.5787 12.0373 40.2431 11.4688 40.0243C10.9002 39.8055 10.2921 39.7084 9.68371 39.7394L6.57289 39.8994C5.67751 39.9419 4.79083 39.707 4.03398 39.2266C3.27713 38.7462 2.687 38.0439 2.34423 37.2155C2.00145 36.3871 1.92273 35.473 2.11883 34.5982C2.31492 33.7233 2.77627 32.9304 3.43985 32.3277L5.75519 30.2386C6.20719 29.8304 6.56853 29.3319 6.81585 28.7753C7.06316 28.2186 7.19095 27.6163 7.19095 27.0072C7.19095 26.3981 7.06316 25.7958 6.81585 25.2392C6.56853 24.6825 6.20719 24.184 5.75519 23.7758L3.43985 21.6868C2.77136 21.0846 2.30584 20.2901 2.10731 19.4124C1.90878 18.5348 1.98701 17.6172 2.33123 16.7859C2.67544 15.9546 3.26874 15.2503 4.0295 14.7701C4.79027 14.2898 5.68113 14.0571 6.57955 14.1039L9.69037 14.2639C10.2999 14.296 10.9094 14.1994 11.4792 13.9805C12.0489 13.7616 12.5663 13.4252 12.9976 12.9932C13.4289 12.5612 13.7644 12.0432 13.9825 11.473C14.2006 10.9028 14.2962 10.2931 14.2633 9.68353L14.1033 6.57216C14.0603 5.67644 14.2948 4.78927 14.7749 4.03191C15.255 3.27455 15.9573 2.68395 16.7856 2.34082C17.614 1.99769 18.5281 1.91878 19.403 2.11487C20.2779 2.31095 21.0709 2.77247 21.6737 3.43634L23.7713 5.74543Z"
                stroke="#E40000"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M34 21L19 36"
                stroke="#E40000"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 21L34 36"
                stroke="#E40000"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="error-modal-red-text">
              Cannot search an empty field! 
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
  <errorModal ref="error_modal" v-on:confirm="closeErrorModal"> </errorModal>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import api from "../../../../services/api";
import successModal from "../../../TablesTemplate/SuccessDialog.vue";
import {mapGetters} from "vuex";
import LayoutAccount from "../Account/LayoutAccount";
import errorModal from "../../../TablesTemplate/ErrorDialog.vue";
export default {
  components: {LayoutAccount, successModal,errorModal },
  data() {
    return {
      loader: false,
      emptySearch: false,
      FavoriteDiagnosis: false,
      FavoriteProcedure: false,
      favoriteProcedures: [],
      favoriteDiagnoses: [],
      title: "",
      description: "",
      DiagnosisDialog: false,
      ProcedureDialog: false,
       icds: [],
      tmpIcds: [],
      tmpCpts: [],
      favCpt: 0,
      facIcd: 0,
      favoriteIcd: [],
      favoriteCpt: [],
      cptmod: [],
      tmpCptmod: [],
      cpts: [],
      modifiers: [],
      results: [],
      diagnose: [],
      procedure: [],
      templates: [],
      template: {
        title: 'Wellness',
        _id: null,
      },
      visitor: {
        member: null,
      },
      diagnoseSearch: "",
      procedureSearch: "",
      showOverlay: false,
      quantity: "1",
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      itemIcds: [],
      icdLink: "",
      requiredRules: [(v) => !!v || "Required"],
      requiredRules1: [(v) => !!v || ""],
    };
  },
  computed: {
    ...mapGetters(["getEligibilityMember"]),
     getIcdsList(){
      return this.icds;
    },
    getCptList(){
      return this.cpts;
    },
    getCptmodList(){
      return this.cptmod;
    },
    singleEmp() {
      let provider = "";
      if (localStorage.getItem("employer")) {
        provider = JSON.parse(localStorage.getItem("employer"));
      }

      return provider;
    },
    isChildren() {
      let bool = false;
      if (this.$route.meta && this.$route.meta.isChildren) {
        bool = true;
      }
      return bool;
    },
  },
  created() {
    // this.getTemplates();
  },
  methods: {
    openDiagnosesDialog(){
      this.DiagnosisDialog = true;
      this.FavoriteDiagnosis = false;
    },
    openFavoriteDiagnosesDialog(){
      this.DiagnosisDialog = false;
      this.FavoriteDiagnosis = true;
    },
    openProcedureDialog(){
      this.ProcedureDialog = true;
      this.FavoriteProcedure = false;
    },
    openFavoriteProcedureDialog(){
      this.ProcedureDialog = false;
      this.FavoriteProcedure = true;
    },
    submitTemplate(){
         const self = this
       let data = {
        title: this.title,
        description: this.description,
        icds:  this.icds.map((value)=>value.code),
        cptmod : this.cptmod,
        cpts: this.cpts.map(function (value, index, array) {
          return {
            cpt: value.code,
            icdLink: self.icds[0].code,
            modifiers: self.cptmod.map(function(value){
             return value.code
            }),
          }
        }),
      }
      this.$refs.templateInfo.validate();
      this.submitFavorites();
      if(this.$refs.templateInfo.validate()){
           api()
          .post(`/dpcproviders/visitreport/template`, data)
          .catch((err) => {
            if (err) {
                this.$refs.error_modal.openPopUp("There was an issue while creating new template.");
              }
          })
          .then((res) => {
            if (res) {
              this.$refs.success_modal.openPopUp("New Template created successfully");
            }
          });
      }
   
    },
    addFavoriteCpt(item,index =null){
      if(this.favoriteProcedures.includes(item)){
        this.favoriteProcedures = this.favoriteProcedures.filter(function (i) {
        return i != item
      })
      }else{
            this.favoriteProcedures.push(item);
      }
    if(index!=null){
        if(this.procedure[index].star==0){
          this.procedure[index].star = 1;
        }else{        
          this.procedure[index].star = 0;
        }
      }
    },
    manageFavoriteCpts(item,index = null){
      if(index!=null){
        const favoriteItem = this.favoriteProcedures[index];
        const procedureIndex = this.procedure.findIndex(procItem => procItem._id === favoriteItem._id);
            if (procedureIndex !== -1) {
                this.procedure[procedureIndex].star = 0;
            } 
            this.favoriteProcedures.splice(index, 1);
    }
    },
    addFavoriteIcd(item, index=null){
      if(this.favoriteDiagnoses.includes(item)){
        this.favoriteDiagnoses = this.favoriteDiagnoses.filter(function (i) {
        return i != item
      })
      }else{
        this.favoriteIcd.push(item);
        this.favoriteDiagnoses.push(item);
      }
      if(index!=null){
        if(this.diagnose[index].star==0){
          this.diagnose[index].star = 1;
        }else{        
          this.diagnose[index].star = 0;
        }  
    }
    },
    manageFavoriteIcd(item, index=null){
      if(index!=null){
        const favoriteItem = this.favoriteDiagnoses[index];
        const diagnoseIndex = this.diagnose.findIndex(diagnoseItem => diagnoseItem._id === favoriteItem._id);
            if (diagnoseIndex !== -1) {
                this.diagnose[diagnoseIndex].star = 0;
            } 
          this.favoriteDiagnoses.splice(index, 1);
    }
    },
    addCPTmod(){
      console.log('add ctpmod');
    },
    getModifiers(){
       api()
          .get(`/visitreport/cptmod`)
          .then((res) => {
            this.modifiers = res.data;
             this.modifiersList=true;
          });
    },
    checkCptmod(item){
       let tmpItem = this.tmpCptmod.filter(function (i) {
        return i == item._id
      })
      if(tmpItem.length > 0 && tmpItem[0] != null){
        this.cptmod.push(item)
      }else{
        this.icds = this.icds.filter(function (i) {
          return i._id != item._id
        })
      }
    },
    removeFromIcds(item){
      this.icds = this.icds.filter(function (i) {
        return i._id != item._id
      });
      this.tmpIcds = this.tmpIcds.filter(function (i) {
        return i == item._id
      })
    },
    removeFromCpt(item){
      this.cpts = this.cpts.filter(function (i) {
        return i._id != item._id
      });
      this.tmpCpts = this.tmpCpts.filter(function (i) {
        return i == item._id
      })
    },
    checkIcds(item){
      let tmpItem = this.tmpIcds.filter(function (i) {
        return i == item._id
      })
      if(tmpItem.length > 0 && tmpItem[0] != null){
        this.icds.push(item)
      }else{
        this.icds = this.icds.filter(function (i) {
          return i._id != item._id
        })
      }
      this.itemIcds = this.icds;
    },
    checkCpts(item){
      let tmpItem = this.tmpCpts.filter(function (i) {
        return i == item._id
      })
      if(tmpItem.length > 0 && tmpItem[0] != null){
        item.quantity = this.quantity;
        item.icdLink = this.icds[0];
        this.cpts.push(item)
      }else{
        this.cpts = this.cpts.filter(function (i) {
          return i._id != item._id
        })
      }
    },
    addICDS(){
      // this.addFavIcd();
      let icds = this.icds;
    },
    addCPTS(){
      //  this.addFavCpts();
      let cpts = this.cpts;
    },
    addCPTmod(){
    let cptmod = this.cptmod
    },
    getTemplates() {
      const member = this.$store.getters.getSingleProviderMember;
      this._id = member._id;
      api()
          .get(`/dpcproviders/visitreport?member=${this._id}`)
          .then((res) => {
            this.templates = res.data.templates;
            this.template._id =res.data.templates._id;

            this.favoriteDiagnoses = res.data.favorites.icds;
            this.favoriteProcedures= res.data.favorites.cpts;
            // this.locations.unshift({ name: "All", _id: null });
          });
    },
    searchDiagnose() {
      this.diagnose = [];
      if (
        this.diagnoseSearch == null ||
        this.diagnoseSearch == "" ||
        !this.diagnoseSearch ||
        this.diagnoseSearch == "undefined"
      ) {
        this.emptySearch = true;
      } else {
        this.loader = true;
        this.DiagnosisDialog = true;
        this.diagnoseSearch = this.diagnoseSearch.trim();
        api()
          .get(`/visitreport/icd?description=${this.diagnoseSearch}`)
          .catch((err) => {
            if (err) {
              this.loader=false;
              }
          })
          .then((res) => {
            if (res) {
              this.tmpIcds = this.icds.map(function (value, index, array) {
                return value._id;
              });
               this.loader=false;
               this.diagnose = res.data.map((item) => ({
              ...item,
              star: this.favoriteDiagnoses.some(fav => fav._id === item._id) ? 1 : 0,
            }));
              this.diagnoseSearch = "";
            }
          })
          .finally(() => {
            this.loader=false;
              });
      }
    },
    searchProcedure() {
      if(this.icds.length < 1){
        this.$refs.error_modal.openPopUp("You need to add a diagnose first");

      }
      this.procedure = [];
      if (
        this.procedureSearch == null ||
        this.procedureSearch == "" ||
        !this.procedureSearch ||
        this.procedureSearch == "undefined"
      ) {
        this.emptySearch = true;
      } else {
        this.loader = true;
        if (this.icds.length == 0) {
          this.errorModal = true;
        } else {
          this.ProcedureDialog = true;
          this.procedureSearch = this.procedureSearch.trim();
          api()
            .get(`/visitreport/cpt?description=${this.procedureSearch}`)
            .catch((err) => {
            if (err) {
              this.loader=false;
              }
          })
            .then((res) => {
              this.loader = false;
              if (res) {
                this.tmpCpts = this.cpts.map(function (value, index, array) {
                  return value._id;
                });
                this.procedure = res.data.map((item) => ({
              ...item,
              star:  this.favoriteProcedures.some(fav => fav._id === item._id) ? 1 : 0,
            }));
                this.procedureSearch = "";
              }
            })
            .finally(() => {
            this.loader=false;
              });
        }
      }
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
      this.$router.go(-1);
    },
    closeErrorModal() {
      this.$refs.error_modal.closePopUp();
    },
    submitFavorites(){
      let data = {
        icds: this.favoriteDiagnoses.map(function (value, index, array) {
          return value._id;
        }),
        cpts: this.favoriteProcedures.map(function (value, index, array) {
          return value._id;
        }),
      }
      api()
            .put(`/dpcproviders/visitreport/favorites`, data)
            .then((res) => {
              console.log('resss',res)
            });
    }
  },
};
</script>
